import React, { FC } from 'react';

import { Model } from '../../index.model';

import { SelectInput } from 'views/components/select-input';

interface Props {
  model: Model;
  onUpdate: (model: Model) => void;
  inFocus: boolean;
}

const CompanyInput: FC<Props> = ({ model, onUpdate, inFocus }) => {

  const list = model.companies.documents.map(it => it.name);
  const index = model.companies.documents.findIndex(it => it.id === model.company?.id);

  function select(index: number) {
    onUpdate(model.change({ company: model.companies.documents[index] }));
  }

  return (
    <SelectInput list={list} index={index} onSelect={i => select(i)} readOnly={true} inFocus={inFocus}>
      <h2>Company</h2>
    </SelectInput>
  );

};

export { CompanyInput };